// Mock data for RSE Post Production House website

export const services = [
  {
    id: 1,
    title: "Wedding Films",
    description: "Cinematic wedding highlights, full films, short films, and teaser editing",
    icon: "Film",
    category: "wedding"
  },
  {
    id: 2,
    title: "Corporate Videos",
    description: "Professional corporate presentations, promotional videos, and brand stories",
    icon: "Briefcase",
    category: "corporate"
  },
  {
    id: 3,
    title: "Social Media Content",
    description: "Instagram Reels, YouTube videos, engaging social media content editing",
    icon: "Share2",
    category: "social-media"
  },
  {
    id: 4,
    title: "Documentary Films",
    description: "Compelling documentary storytelling and professional film editing",
    icon: "Video",
    category: "documentary"
  },
  {
    id: 5,
    title: "AD Films",
    description: "Creative advertisement films and commercial video editing",
    icon: "Tv",
    category: "commercial"
  },
  {
    id: 6,
    title: "Event Highlights",
    description: "Event coverage, highlights, and teaser videos for any occasion",
    icon: "Camera",
    category: "events"
  },
  {
    id: 7,
    title: "Education Videos",
    description: "Educational content, tutorials, and e-learning video editing",
    icon: "BookOpen",
    category: "education"
  },
  {
    id: 8,
    title: "Short Films",
    description: "Creative storytelling through expertly edited short films",
    icon: "Clapperboard",
    category: "short-film"
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Royal Wedding Film",
    description: "A cinematic journey of love and celebration",
    category: "Wedding Film",
    thumbnail: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80",
    videoUrl: "#",
    client: "Private Client"
  },
  {
    id: 2,
    title: "Tech Company Promo",
    description: "Corporate brand story for leading IT company",
    category: "Corporate",
    thumbnail: "https://images.unsplash.com/photo-1551818255-e6e10975bc17?w=800&q=80",
    videoUrl: "#",
    client: "TechCorp Ltd."
  },
  {
    id: 3,
    title: "Instagram Reel Series",
    description: "Viral social media content for fashion brand",
    category: "Social Media",
    thumbnail: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&q=80",
    videoUrl: "#",
    client: "Fashion Forward"
  },
  {
    id: 4,
    title: "Heritage Documentary",
    description: "Cultural heritage preservation documentary",
    category: "Documentary",
    thumbnail: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=800&q=80",
    videoUrl: "#",
    client: "Cultural Trust"
  },
  {
    id: 5,
    title: "Product Launch AD",
    description: "High-impact commercial for product launch",
    category: "AD Film",
    thumbnail: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800&q=80",
    videoUrl: "#",
    client: "Brand XYZ"
  },
  {
    id: 6,
    title: "Annual Gala Event",
    description: "Corporate event highlights and teaser",
    category: "Event",
    thumbnail: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80",
    videoUrl: "#",
    client: "Enterprise Inc."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rahul Patel",
    role: "Wedding Client",
    content: "RSE created the most beautiful wedding film we could have imagined. Their attention to detail and creative vision exceeded all our expectations.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80"
  },
  {
    id: 2,
    name: "Priya Shah",
    role: "Corporate Client",
    content: "Professional, creative, and timely delivery. RSE transformed our corporate message into a compelling visual story. Highly recommended!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80"
  },
  {
    id: 3,
    name: "Amit Desai",
    role: "Content Creator",
    content: "Working with RSE for my YouTube content has been amazing. They understand the platform and deliver high-quality edits that engage viewers.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&q=80"
  },
  {
    id: 4,
    name: "Sneha Mehta",
    role: "Event Organizer",
    content: "RSE captured our event perfectly. The highlight reel was stunning and helped us promote future events effectively.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Senior Editor",
    role: "Lead Video Editor",
    expertise: "Wedding Films & Documentaries"
  },
  {
    id: 2,
    name: "Creative Director",
    role: "Creative Lead",
    expertise: "AD Films & Corporate Videos"
  },
  {
    id: 3,
    name: "Motion Graphics Specialist",
    role: "VFX Editor",
    expertise: "Motion Graphics & Visual Effects"
  },
  {
    id: 4,
    name: "Social Media Expert",
    role: "Content Editor",
    expertise: "Reels & Social Media Content"
  }
];

export const packages = [
  {
    id: 1,
    name: "Basic Package",
    description: "Perfect for small projects and social media content",
    features: [
      "Up to 5 minutes edited video",
      "Basic color correction",
      "Background music",
      "2 rounds of revisions",
      "HD 1080p delivery"
    ],
    price: "Starting from ₹15,000",
    duration: "3-5 days",
    popular: false
  },
  {
    id: 2,
    name: "Professional Package",
    description: "Ideal for corporate videos and events",
    features: [
      "Up to 15 minutes edited video",
      "Advanced color grading",
      "Custom music & sound design",
      "Motion graphics & titles",
      "4 rounds of revisions",
      "4K delivery available"
    ],
    price: "Starting from ₹35,000",
    duration: "7-10 days",
    popular: true
  },
  {
    id: 3,
    name: "Premium Package",
    description: "Complete solution for weddings and films",
    features: [
      "Up to 45 minutes edited video",
      "Cinematic color grading",
      "Original score & sound design",
      "Advanced VFX & motion graphics",
      "Unlimited revisions",
      "4K & HDR delivery",
      "Multi-format export"
    ],
    price: "Starting from ₹75,000",
    duration: "15-20 days",
    popular: false
  }
];

export const stats = [
  {
    id: 1,
    number: "8+",
    label: "Years Experience",
    icon: "Trophy"
  },
  {
    id: 2,
    number: "500+",
    label: "Projects Completed",
    icon: "CheckCircle"
  },
  {
    id: 3,
    number: "8",
    label: "Expert Editors",
    icon: "Users"
  },
  {
    id: 4,
    number: "100%",
    label: "Client Satisfaction",
    icon: "Heart"
  }
];
